import { render, staticRenderFns } from "./TabbedNavigation.vue?vue&type=template&id=1e0bde87"
import script from "./TabbedNavigation.vue?vue&type=script&lang=js"
export * from "./TabbedNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports